import React, { FC } from 'react';
import styles from './BigWinItem.module.scss';
import { PropertyType } from 'esa-ui-library/lib/types';
import game from '../../../../../common/images/casino.png';
import { toAmountString } from '../../../../../common';

interface BigWinItemProps {
	data: PropertyType;
}

const BigWinItem: FC<BigWinItemProps> = ({ data }) => {
	return (
		<div className={styles.Item} data-testid='big-wins-item'>
			<div className={styles.Image}>
				<img src={game} alt='game' />
			</div>
			<div className={styles.Value}>{toAmountString(data.win, 'EUR')}</div>
			<div>
				<div className={styles.Title}>{data.game_name}</div>
				<div className={styles.Text}>ID: {data.game_id}</div>
			</div>
		</div>
	);
};

export { BigWinItem };
